import React, { FC, useState } from 'react';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { MultiDepartmentSelector } from 'src/features/departments';
import { MultiTeamSelector } from 'src/features/teams';
import { FilterListIcon, IconButton } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

interface Props {
  departmentIds: number[];
  teamIds: number[];
  onDepartmentIdsChange: (selected: number[]) => void;
  onTeamIdsChange: (selected: number[]) => void;
}

export const MessageCenterDetailsToFilters: FC<Props> = ({
  departmentIds,
  teamIds,
  onDepartmentIdsChange,
  onTeamIdsChange,
}) => {
  const { t } = useTranslate();

  const [filterEl, setFilterEl] = useState<null | HTMLElement>(null);

  const filterOpen = Boolean(filterEl);

  const handleFilterOpen = (event: React.MouseEvent<HTMLElement>) => {
    setFilterEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterEl(null);
  };

  return (
    <>
      <IconButton onClick={handleFilterOpen}>
        <FilterListIcon />
      </IconButton>
      <Popover
        anchorEl={filterEl}
        open={filterOpen}
        onClose={handleFilterClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: { width: '100%', maxWidth: 300, p: 2 },
          },
        }}
        sx={{ mt: 1 }}
      >
        <Stack direction="column" gap={2}>
          <Typography variant="caption" color={(theme) => theme.palette.text.secondary}>
            {t('global.filters')}
          </Typography>
          <Stack direction="column" gap={1}>
            <Typography variant="caption" color={(theme) => theme.palette.text.secondary}>
              {t('messageCenter.departments')}
            </Typography>
            <MultiDepartmentSelector ids={departmentIds} onChange={onDepartmentIdsChange} />
          </Stack>
          <Stack direction="column" gap={1}>
            <Typography variant="caption" color={(theme) => theme.palette.text.secondary}>
              {t('messageCenter.teams')}
            </Typography>
            <MultiTeamSelector ids={teamIds} onChange={onTeamIdsChange} />
          </Stack>
        </Stack>
      </Popover>
    </>
  );
};
